var map = {
	"./allianz/logo-mini.svg": 446,
	"./allianz/logo.svg": 90702,
	"./icons/arrow-down.svg": 99352,
	"./icons/arrow-left.svg": 9879,
	"./icons/arrow-right.svg": 93266,
	"./icons/arrow-up.svg": 40395,
	"./icons/customers.svg": 37307,
	"./icons/digital.svg": 34576,
	"./icons/download.svg": 73472,
	"./icons/filter.svg": 77502,
	"./icons/link.svg": 1920,
	"./icons/logo-mini.svg": 73683,
	"./icons/logo.svg": 79029,
	"./icons/menu.svg": 44645,
	"./icons/message.svg": 14997,
	"./icons/reply.svg": 18164,
	"./icons/sales.svg": 70184,
	"./icons/settings.svg": 45559,
	"./icons/user.svg": 13265,
	"./logo-blue.svg": 31433,
	"./prodigys/logo-mini.svg": 27432,
	"./prodigys/logo.svg": 14688,
	"./symbol-defs.svg": 11862
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6324;